<template>
    <div style="padding: 16px; background: lightgray;">

        <div style="background:white; padding: 16px; direction:rtl; max-width: 600px; margin: auto; border-radius: 5px; box-shadow: 0 2px 8px rgba(0, 0, 0, .33)">

            <div style="position: relative;display: inline-block; width: 100%">
                <img src="https://firebasestorage.googleapis.com/v0/b/travelquest-da6b2.appspot.com/o/TQ%2Flong%20screen.png?alt=media&token=2762a85f-89fd-448f-a913-146df1651060"
                     style="width: 100%; border-radius: 5px;"/>
                <div style="background: rgba(0, 0, 0, 0.6);  position: absolute;  right: 0; bottom: 8px; padding: 4px; color: white; border-radius: 5px; font-size: 24px">
                    תודה שבחרת טרוול קווסט
                </div>
            </div>

            <hr style="margin: 16px 0;">


            <div >
                שלום
                <strong>
                    "תותחים מלידה",
                </strong>
                אנחנו חייבים להגיד שפשוט הייתם 10!

            </div>

            <hr style="margin: 16px 0;">

            <div>

                <div style="font-size: 20px; margin-bottom: 8px">
                    התמונות שלכם:
                </div>

                <div style="text-align: center; margin: auto;">

                    <img :src="images_as[0]" style="max-width:250px; width: 100%; margin: 8px; border-radius: 4px; "/>
                    <img :src="images_as[1]" style="max-width:250px; width: 100%; margin: 8px; border-radius: 4px"/>
                    <img :src="images_as[2]" style="max-width:250px; width: 100%; margin: 8px; border-radius: 4px"/>
                    <img :src="images_as[3]" style="max-width:250px; width: 100%; margin: 8px; border-radius: 4px"/>
                </div>

            </div>

            <hr>

            <div >

                <strong >
                    אנחנו תמיד כאן בשבילכם.
                </strong>

                <div>
                    תרגישו חופשי ליצור איתנו קשר
                </div>

                <div>
                    לייצרת קשר באיימל: dan@travelAndQuest.com
                </div>



            </div>

        </div>

        <div style="text-align: center; margin: auto; margin-top: 16px;">

            <img style="background: #1DA1F2; padding: 8px; margin: 8px; border-radius: 16px" width="32px"
                 src="https://firebasestorage.googleapis.com/v0/b/travelquest-da6b2.appspot.com/o/TQ%2Ftwitter_w.svg?alt=media&token=b4eb7104-e17b-4f97-a38c-755fdd6a95fe"/>

            <img style="background: #E1306C; padding: 8px; margin: 8px; border-radius: 16px" width="32px"
                 src="https://firebasestorage.googleapis.com/v0/b/travelquest-da6b2.appspot.com/o/TQ%2Finstagram_w.svg?alt=media&token=88078d2c-e472-4089-8d74-c5486fe245e0"/>

            <img style="background: #3C5A99; padding: 8px; margin: 8px; border-radius: 16px" width="32px"
                 src="https://firebasestorage.googleapis.com/v0/b/travelquest-da6b2.appspot.com/o/TQ%2FfacebookLetter_w.svg?alt=media&token=28e7e3fa-2d61-4b2e-ae64-cd46295c0835"/>

            <a href="https://travelquest.xyz/iw">
                <img style="background: #753679; margin: 8px; border-radius: 16px" width="48px"
                     src="../../assets/svg/logoFull.svg"/>
            </a>
        </div>




    </div>
</template>

<script>
    export default {
        name: "v_Email_QuestEventEndSummary",

        data(){
            return {
                images_as : [
                    "https://firebasestorage.googleapis.com/v0/b/travelquest-da6b2/o/TEAMS_STATUS%2FOPEN_MAP%2F-L7U7bVCe8HdemOdh5UM%2F-L_aesWxZrt-wP4OqWtR%2F-L_flL9UqGG4IDfAIVrt%2FlockImage_11_0_0_0.jpg?alt=media&token=627fce09-e218-44ea-83bf-82638e8559cc",
                    "https://firebasestorage.googleapis.com/v0/b/travelquest-da6b2/o/TEAMS_STATUS%2FOPEN_MAP%2F-L7U7bVCe8HdemOdh5UM%2F-LdihFxV0HVMzaYjoDXl%2F-LdihfvDNTWH-wu07oLp%2FlockImage_11_0_0_0.jpg?alt=media&token=228e7984-2327-452f-8b2e-1c8b712b7626",
                    "https://firebasestorage.googleapis.com/v0/b/travelquest-da6b2/o/TEAMS_STATUS%2FOPEN_MAP%2F-L7U7bVCe8HdemOdh5UM%2F-LdihFxV0HVMzaYjoDXl%2F-LdihfvDNTWH-wu07oLp%2FlockImage_14_0_0_0.jpg?alt=media&token=b5b39a09-8223-48f6-b4cb-99b35c157914",
                    "https://firebasestorage.googleapis.com/v0/b/travelquest-da6b2/o/TEAMS_STATUS%2FOPEN_MAP%2F-L7U7bVCe8HdemOdh5UM%2F-LdihFxV0HVMzaYjoDXl%2F-LdihfvDNTWH-wu07oLp%2FlockImage_7_0_0_0.jpg?alt=media&token=7272b7ed-3f26-48a6-9bd5-ce561030d6d9",
                ]
            }
        }
    }
</script>

<style scoped>
</style>